import { z } from 'zod';
import { IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * T-TASKAUTO-1 — task-automation rule entity schema (source of truth for shape).
 *
 * Hybrid trigger model (Kenny 2026-06-03): one schema covers scheduled + event
 * rules via the `triggerKind` discriminator. `condition` and `taskTemplate` are
 * structured here (and at the evaluator, T-TASKAUTO-2) but stored as JSONB.
 */
export const TASK_AUTOMATION_TRIGGER_KINDS = ['scheduled', 'event'];
export const TaskAutomationTriggerKindSchema = z.enum(TASK_AUTOMATION_TRIGGER_KINDS);
/** Scheduled (time-relative) condition. */
export const ScheduledConditionSchema = z.object({
    entity: z.enum(['account', 'deal', 'submission']),
    predicate: z.enum(['inactivity_days', 'days_before_term', 'not_submitted_days']),
    days: z.number().int().positive(),
});
/** Event condition — optional matchers narrowing when the event rule fires. */
export const EventConditionSchema = z.object({
    toState: z.string().optional(),
    fromState: z.string().optional(),
});
/** Stored condition is one of the two shapes (kept permissive at the entity layer;
 *  the evaluator narrows by triggerKind). */
export const TaskAutomationConditionSchema = z.union([
    ScheduledConditionSchema,
    EventConditionSchema,
]);
export const TaskAutomationTemplateSchema = z.object({
    title: z.string().min(1),
    description: z.string().optional(),
    assigneePolicy: z.enum(['self', 'account_rep', 'fixed']),
    assigneeEmail: z.string().optional(),
    dueOffsetDays: z.number().int().optional(),
});
export const TaskAutomationRuleSchema = z.object({
    id: z.string(),
    type: z.literal('task_automation_rule'),
    schemaVersion: SchemaVersionSchema,
    name: z.string(),
    enabled: z.boolean(),
    triggerKind: TaskAutomationTriggerKindSchema,
    /** Null for scheduled rules; the emit-point key for event rules. */
    triggerEvent: z.string().nullable(),
    condition: TaskAutomationConditionSchema,
    taskTemplate: TaskAutomationTemplateSchema,
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    deletedAt: IsoTimestampSchema.nullable(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=task-automation-rule.js.map